import Choices from 'choices.js';

/**
 * Init custom select element with choices.js
 * 
 * @param {string|HTMLSelectElement} el - HTML select element or select element CSS selector
 * @param {object} options - Optional settings
 * @param {boolean} [options.allowHTML=false] - @link https://github.com/Choices-js/Choices#allowhtml
 * @param {string} [options.itemSelectText] - @link https://github.com/Choices-js/Choices#itemselecttext
 * @param {string} [options.noResultsText] - @link https://github.com/Choices-js/Choices#noresultstext
 * @param {string} [options.noChoicesText] - @link https://github.com/Choices-js/Choices#nochoicestext
 * @param {'auto'|'top'|'bottom'} [options.position='auto'] - @link https://github.com/Choices-js/Choices#position
 *
 * @returns {Choices}
 */
export const initSelect = (el, options = {}) => {
  const selectEl = (typeof el === 'string') ? document.querySelector(el) : el;
  const _defaults = {
    allowHTML: false,
    itemSelectText: '',
    noResultsText: selectEl.dataset.choicesNoResultsText,
    noChoicesText: selectEl.dataset.choicesNoChoicesText,
    position: selectEl.dataset.choicesPosition || 'auto',
  }
  const opts = { ..._defaults, ...options };
  const classNames = {
    ...(opts.classNames || {}),
  };

  if (opts.position === 'bottom') {
    classNames.flippedState = 'is-flipped-disabled';
  }

  const choices = new Choices(selectEl, {
    allowHTML: opts.allowHTML,
    itemSelectText: opts.itemSelectText,
    noResultsText: opts.noResultsText,
    noChoicesText: opts.noChoicesText,
    position: opts.position,
    classNames,
  });

  if (opts.position === 'bottom') {
    choices.containerOuter.element.classList.add('choices--position-bottom');
  }

  return choices;
};
